import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

import AgeSuitabilitiesActions from 'app/actions/AgeSuitabilitiesActions';
import UgcEditorActions from 'app/actions/UgcEditorActions';
import ModalActions from 'app/actions/ModalActions';

import { ugcAgeSuitabilityShape, catalogBibShape } from '@bibliocommons/bc-prop-types';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import {
  selectCurrentUserAgeSuitabilities,
  selectAgeSuitabilitiesTransactions
} from 'app/selectors/ugc/AgeSuitabilitiesSelector';
import { selectOpenUgcEditors } from 'app/selectors/ui/UgcEditorSelector';
import AgeRatingEditor from './AgeRatingEditor';

export function AgeRatingEditorContainer(props) {
  return <AgeRatingEditor {...props} />;
}

AgeRatingEditorContainer.propTypes = {
  handleSuccess: PropTypes.func.isRequired,
  currentUserAgeSuitability: ugcAgeSuitabilityShape,
  metadataId: PropTypes.string,
  catalogBib: catalogBibShape.isRequired,
  ageSuitabilitiesTransactions: ImmutablePropTypes.map.isRequired,
  ageSuitabilitiesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ugcEditorActions: PropTypes.objectOf(PropTypes.func).isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = state => {
  const catalogBib = selectCatalogBib(state);
  const metadataId = catalogBib.get('metadataId');
  return {
    currentUserAgeSuitability: selectCurrentUserAgeSuitabilities(state).get(metadataId),
    metadataId,
    ageSuitabilitiesTransactions: selectAgeSuitabilitiesTransactions(state),
    open: selectOpenUgcEditors(state).has('ageRating'),
    catalogBib
  };
};

const mapDispatchToProps = dispatch => ({
  ageSuitabilitiesActions: bindActionCreators(AgeSuitabilitiesActions, dispatch),
  ugcEditorActions: bindActionCreators(UgcEditorActions, dispatch),
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AgeRatingEditorContainer);
